const customerInfo = {
  state: {
    customer_login_id: '',
    deadline: '',
    email: '',
    email_bride: '',
    hall_name: '',
    isum_flg: '',
    isum_limit: '',
    kana01: '',
    kana02: '',
    kana01_2: '',
    kana02_2: '',
    name01: '',
    name02: '',
    name01_2: '',
    name02_2: '',
    other_song_flg: '',
    other_song_limit: '',
    playlistCommit: '',
    status: '',
    wedding_date: '',
    isum_bring_flg: '',
    other_song_bring_flg: '',
    login_flg: ''
  },
  mutations: {
    customerModuleUpdateState (state, obj) {
      state = obj
    },
    /**
     * 新郎の名前情報をstateにセットする
     * @param state
     * @param lastName
     * @param firstName
     */
    updateGroomName (state, [lastName, firstName]) {
      state.name01 = lastName
      state.name02 = firstName
    },
    /**
     * 新婦の名前情報をstateにセットする
     * @param state
     * @param lastName
     * @param firstName
     */
    updateBrideName (state, [lastName, firstName]) {
      state.name01_2 = lastName
      state.name02_2 = firstName
    },
    /**
     * 新郎の名前(カナ)情報をstateにセットする
     * @param state
     * @param lastName
     * @param firstName
     */
    updateGroomNameKana (state, [lastName, firstName]) {
      state.kana01 = lastName
      state.kana02 = firstName
    },
    /**
     * 新婦の名前(カナ)情報をstateにセットする
     * @param state
     * @param lastName
     * @param firstName
     */
    updateBrideNameKana (state, [lastName, firstName]) {
      state.kana01_2 = lastName
      state.kana02_2 = firstName
    },
    updateStatus (state, status) {
      state.status = status
    },
    updateWeddingDate (state, weddingDate) {
      state.wedding_date = weddingDate
    },
    updateEmail (state, [groomEmail, brideEmail]) {
      state.email = groomEmail
      state.email_bride = brideEmail
    },
    updateIsumLimit (state, limit) {
      state.isum_limit = limit
    },
    updateOtherSongLimit (state, limit) {
      state.other_song_limit = limit
    },
    updateIsumFlag (state, flg) {
      state.isum_flg = flg
    },
    updateOtherSongFlag (state, flg) {
      state.other_song_flg = flg
    },
    updatePlayListCommitStatus (state, status) {
      state.playlistCommit = status
    },
    udateIsumBringFlag (state, flg) {
      state.isum_bring_flg = flg
    },
    updateOtherSongBringFlag (state, flg) {
      state.other_song_bring_flg = flg
    },
    updateLoginFlag (state, flg) {
      state.login_flg = flg
    },
    setCustomerInfo (context, customerInfo) {
      for (let key in context.state) {
        if (!customerInfo.hasOwnProperty(key)) {
          customerInfo[key] = ''
        }
      }
      this.commit('customerModuleUpdateState', customerInfo)
      this.commit('updateStatus', customerInfo['status'])
      this.commit('updateGroomName', [customerInfo['name01'], customerInfo['name01_2']])
      this.commit('updateBrideName', [customerInfo['name02'], customerInfo['name02_2']])
      this.commit('updateGroomNameKana', [customerInfo['kana01'], customerInfo['kana01_2']])
      this.commit('updateBrideNameKana', [customerInfo['kana02'], customerInfo['kana02_2']])
      this.commit('updateEmail', [customerInfo['email'], customerInfo['email_bride']])
      this.commit('updateWeddingDate', customerInfo['wedding_date'])
      this.commit('updateIsumLimit', customerInfo['isum_limit'])
      this.commit('updateOtherSongLimit', customerInfo['other_song_limit'])
      this.commit('updateIsumFlag', customerInfo['isum_flg'])
      this.commit('updateOtherSongFlag', customerInfo['other_song_flg'])
      this.commit('updatePlayListCommitStatus', customerInfo['playlist_commit'])
      this.commit('udateIsumBringFlag', customerInfo['isum_bring_flg'])
      this.commit('updateOtherSongBringFlag', customerInfo['other_song_bring_flg'])
      this.commit('updateLoginFlag', customerInfo['login_flg'])
      // this.commit('updateShowFlag', booleanShowModal)
    }
  },
  actions: {},
  getters: {
    customerModuleGetState (state) {
      return state
    },
    getGroomLastName (state) {
      return state.name01
    },
    getGroomFirstName (state) {
      return state.name01_2
    },
    getBrideLastName (state) {
      return state.name02
    },
    getBrideFirstName (state) {
      return state.name02_2
    },
    getGroomLastNameKana (state) {
      return state.kana01
    },
    getGroomFirstNameKana (state) {
      return state.kana01_2
    },
    getBrideLastNameKana (state) {
      return state.kana02
    },
    getBrideFirstNameKana (state) {
      return state.kana02_2
    },
    getGroomEmail (state) {
      return state.email
    },
    getBrideEmail (state) {
      return state.email_bride
    },
    getUserStatusNumber (state) {
      return parseInt(state.status)
    },
    getWeddingDate (state) {
      return state.wedding_date
    },
    getIsumLimit (state) {
      return state.isum_limit
    },
    getOtherSongLimit (state) {
      return state.other_song_limit
    },
    customerModulePlayListCommit (state) {
      return state.playlistCommit
    },
    getIsumFlag (state) {
      return state.isum_flg
    },
    getOtherSongFlag (state) {
      return state.other_song_flg
    },
    getUserLoginFlg (state) {
      return parseInt(state.login_flg)
    }
  }
}
export default customerInfo



// WEBPACK FOOTER //
// ./src/store/CustomerInfo.js